import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useAssignSettingPersistQuickAddOnSearchTile } from "@faire/retailer-visitor-shared/settings/useSettingPersistQuickAddOnSearchTile";
import React from "react";
export var useAssignPersistQuickAddOnSearchTile = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var assignPersistQuickAdd = useAssignSettingPersistQuickAddOnSearchTile();
    React.useEffect(function() {
        if (isLoggedInRetailer) {
            assignPersistQuickAdd();
        }
    }, [
        isLoggedInRetailer,
        assignPersistQuickAdd
    ]);
};
